import React from "react";
import {
  formatFechaHoraCierre,
  formatNumeroCierre,
} from "./ajusteMensualesFormatters";
import "./AjusteMensuales.css";

/**
 * Columnas alineadas al diseño de referencia: Cierre de día (19 columnas).
 */
const AjusteMensualesConsultaDiaTable = ({ cierres }) => {
  if (!Array.isArray(cierres) || cierres.length === 0) {
    return null;
  }

  return (
    <div className="ajuste-mensuales-scroll">
      <table className="ajuste-mensuales-data-table">
        <thead>
          <tr>
            <th>COD_TERMINAL</th>
            <th>COD_PARK</th>
            <th>FECHA_FINAL</th>
            <th>ID_INICIO_DIA</th>
            <th>FACTURA_INI</th>
            <th>FACTURA_FIN</th>
            <th>TURNOS</th>
            <th>TOTAL</th>
            <th>SUBTOTAL</th>
            <th>TOTAL_EFECTIVO_DIA</th>
            <th>TOTAL_EFECTIVO</th>
            <th>TOTAL_TC</th>
            <th>TOTAL_MENSUALES_EF</th>
            <th>TOTAL_MENSUALES_TC</th>
            <th>IVA_EFECTIVO</th>
            <th>IVA_DATAFONO</th>
            <th>TOTAL_NOTAS_CREDITO</th>
            <th>ESTADO</th>
            <th>ID_PLANILLA</th>
          </tr>
        </thead>
        <tbody>
          {cierres.map((r) => {
            const id = r.idCierreDia ?? r.id;
            return (
              <tr key={id}>
                <td>{r.codTerminal ?? ""}</td>
                <td>{r.codPark ?? ""}</td>
                <td>{formatFechaHoraCierre(r.fechaFinal)}</td>
                <td>{r.idInicioDia ?? ""}</td>
                <td>{r.facturaIni ?? ""}</td>
                <td>{r.facturaFin ?? ""}</td>
                <td>{r.turnos ?? ""}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.total)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.subtotal)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalEfectivoDia)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalEfectivo)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalTc)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalMensualesEf)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalMensualesTc)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.ivaEfectivo)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.ivaDatafono)}</td>
                <td className="ajuste-mensuales-num">{formatNumeroCierre(r.totalNotasCredito)}</td>
                <td>{r.estado ?? ""}</td>
                <td>{r.idPlanilla ?? ""}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AjusteMensualesConsultaDiaTable;
